export interface ServiceGroup {
  number: string;
  title: string;
  featured?: boolean;
  items: string[];
}

export interface ResultPair {
  label: string;
  title: string;
  before: string;
  beforeAlt: string;
  after: string;
  afterAlt: string;
}

export const serviceGroups: ServiceGroup[] = [
  {
    number: '01',
    title: 'Exterior Detail',
    items: [
      'Wheels and tires cleaned',
      'Pre-foam and rinse',
      'Bug and road film removal',
      'Panel-by-panel foam hand wash',
      'Exterior glass cleaned',
      'Foam sealant protection',
      'Hand and air dry',
    ],
  },
  {
    number: '02',
    title: 'Interior Detail',
    featured: true,
    items: [
      'Air blowout for cracks and crevices',
      'Full interior vacuum',
      'Floor mats cleaned',
      'Interior surface cleaning',
      'Light steam sanitization',
      'Interior protectant applied',
      'Interior glass cleaned',
    ],
  },
  {
    number: '03',
    title: 'Extras and Add-Ons',
    items: [
      'Paint correction',
      'DA polishing with Rupes and Worx machines',
      'Tar removal',
      'Carpet shampoo',
      'Pet hair removal',
      'Headlight restoration',
      'More options available by request',
    ],
  },
];

export const resultPairs: ResultPair[] = [
  {
    label: 'Interior reset',
    title: 'Cup holders, panels, and hard-to-reach spaces brought back.',
    before: 'assets/cupholder-before.jpg',
    beforeAlt: 'Dirty rear cup holder before interior detailing',
    after: 'assets/cupholder-after.jpg',
    afterAlt: 'Clean rear cup holder after interior detailing',
  },
  {
    label: 'Surface cleaning',
    title: 'Door panels and touch points cleaned without the greasy look.',
    before: 'assets/door-before.jpg',
    beforeAlt: 'Dirty interior truck door before detailing',
    after: 'assets/door-after.jpg',
    afterAlt: 'Clean interior truck door after detailing',
  },
  {
    label: 'Adhesive removal',
    title: 'Tape residue from a removed bumper guard cleaned off the finish.',
    before: 'assets/adhesive-before.jpg',
    beforeAlt: 'Tape residue left after a bumper guard was removed',
    after: 'assets/adhesive-after.jpg',
    afterAlt: 'Clean vehicle surface after tape residue removal',
  },
];

export const methodCards = [
  {
    number: '01',
    title: 'Koch Chemie products',
    copy: 'Trusted detailing chemistry selected for clean results, proper surface care, and a professional finish.',
  },
  {
    number: '02',
    title: 'Safe rinse setup',
    copy: '2.3 gallons per minute keeps water flowing while 1000 PSI stays gentle for automotive surfaces.',
  },
  {
    number: '03',
    title: 'DA polishing tools',
    copy: 'Rupes and Worx dual-action polishers are used with Koch Chemie pads and polishes for controlled correction work.',
  },
  {
    number: '04',
    title: 'Condition-based approach',
    copy: 'Each vehicle is looked over for tar, road film, interior grime, glass, wheels, and problem areas before the work starts.',
  },
];
